var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeInprogress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12909",
    "data-name": "Group 12909",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2452",
    "data-name": "Rectangle 2452",
    width: 32,
    height: 32,
    fill: "#df6800"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12908",
    "data-name": "Group 12908",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12912",
    "data-name": "Path 12912",
    d: "M3.531,12.274q6.545.01,13.09,0a1,1,0,0,0,.989-.5.988.988,0,0,0-.134-1.1c-.53-.784-1.059-1.569-1.571-2.364a1,1,0,0,1-.153-.509c-.012-1.451,0-2.9-.009-4.353A3.237,3.237,0,0,0,14.271.624,8.386,8.386,0,0,0,12.784,0H2.964A8.6,8.6,0,0,0,1.71.468,3.248,3.248,0,0,0,.058,2.8,1.226,1.226,0,0,1,0,2.964V9.325A.263.263,0,0,1,.048,9.4a3.382,3.382,0,0,0,3.484,2.873M1.853,3.584A1.573,1.573,0,0,1,3.571,1.853q4.3,0,8.61,0a1.571,1.571,0,0,1,1.712,1.706c0,1.5.01,3-.006,4.505a1.754,1.754,0,0,0,.337,1.093c.281.391.538.8.849,1.266H3.681a1.61,1.61,0,0,1-1.829-1.84q0-2.5,0-5",
    fill: "#df6800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12913",
    "data-name": "Path 12913",
    d: "M63.677,56.642c.987.013,1.974,0,2.962,0s1.954,0,2.931,0a.924.924,0,1,0,0-1.847c-.8-.014-1.6,0-2.406,0H63.765a.943.943,0,0,0-.96.588.911.911,0,0,0,.872,1.261",
    transform: "translate(-58.765 -51.325)",
    fill: "#df6800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12914",
    "data-name": "Path 12914",
    d: "M66.58,109.762c-.935-.011-1.871-.006-2.806,0a1.321,1.321,0,0,0-.423.069.913.913,0,0,0-.59.948.874.874,0,0,0,.8.809c.533.029,1.068.007,1.6.007v.014h1.48a.925.925,0,1,0-.061-1.847",
    transform: "translate(-58.786 -102.814)",
    fill: "#df6800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12915",
    "data-name": "Path 12915",
    d: "M322.173,315.99h-.011a.91.91,0,0,0-.909.916,6.362,6.362,0,0,1-.066.729,4.271,4.271,0,0,1-1.759,2.806,4.363,4.363,0,1,1-.939-7.6l.091.038c-.078.076-.153.152-.229.23a.9.9,0,0,0,.636,1.531c.344,0,.723,0,1.119,0,.332,0,.675,0,1.021,0a.887.887,0,0,0,.883-.893c0-.673,0-1.365,0-2.115a.924.924,0,0,0-.08-.374.9.9,0,0,0-.734-.526.931.931,0,0,0-.1-.005.859.859,0,0,0-.285.049.967.967,0,0,0-.37.239l-.5.507-.005.005a6.059,6.059,0,0,0-3.006-.8,6.559,6.559,0,0,0-1.252.123,6.178,6.178,0,0,0-4.959,6.034,6.109,6.109,0,0,0,.092,1.068,6.308,6.308,0,0,0,.2.8,6.174,6.174,0,0,0,5.871,4.322,6.184,6.184,0,0,0,6.189-6.129.906.906,0,0,0-.9-.95",
    transform: "translate(-291.07 -291.069)",
    fill: "#df6800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12916",
    "data-name": "Path 12916",
    d: "M18.372,56.576a7.491,7.491,0,0,1-.113-1.308l-4.286,0A.552.552,0,0,1,13.447,55a7.172,7.172,0,0,0-2.723-2.4c-.088-.045-.173-.1-.272-.151a5.238,5.238,0,0,0,1.307-6.236H29.745v1.53a2.261,2.261,0,0,1,.285-.018,2.325,2.325,0,0,1,1.59.63V45.505c0-.082,0-.165,0-.247a.927.927,0,0,0-.907-.91c-.182-.009-.366,0-.573,0a5.944,5.944,0,0,0-2.967-5.181,4.458,4.458,0,0,0,.125-6.487,4.4,4.4,0,0,0-5.858-.216A4.241,4.241,0,0,0,19.9,35.2a4.4,4.4,0,0,0,1.437,3.959,5.948,5.948,0,0,0-2.985,5.19h-.37c-2.491,0-4.982,0-7.473-.008a1.315,1.315,0,0,1-.654-.191A5.065,5.065,0,0,0,6.4,43.412a5.132,5.132,0,0,0-3.432,8.08c.3.4.663.748,1,1.123-.039.024-.1.063-.161.1a7.286,7.286,0,0,0-3.47,4.277C.176,57.5.109,58.029,0,58.549V60.4a1.056,1.056,0,0,0,.967.68q6.407,0,12.814,0a.917.917,0,0,0,.97-.973c0-.565-.009-1.132-.053-1.7-.033-.425-.128-.844-.2-1.271h3.99q-.07-.278-.121-.563m5.769-23.268a2.535,2.535,0,0,1,.237,5.065,2.535,2.535,0,1,1-.237-5.065m.088,6.942a4.01,4.01,0,0,1,4.032,4.075H20.23a4.006,4.006,0,0,1,4-4.075M3.835,48.481a3.293,3.293,0,1,1,3.294,3.3,3.309,3.309,0,0,1-3.294-3.3m9.047,10.734H1.849a5.383,5.383,0,0,1,2.433-4.608,5.28,5.28,0,0,1,5.778-.255,5.39,5.39,0,0,1,2.822,4.863",
    transform: "translate(0 -29.461)",
    fill: "#df6800"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeInprogress);
export default __webpack_public_path__ + "static/media/orange-Inprogress.68a59a709c4975891d109a5107da2232.svg";
export { ForwardRef as ReactComponent };